export default "__VITE_ASSET__C6h4tq3C__"